import { NgModule } from '@angular/core';
import { AsyncPipe, NgForOf, NgIf, NgStyle } from '@angular/common';
import { B2bDynamicLoaderDirective } from './directives/b2b-dynamic-loader.directive';
import { B2bDynamicLoaderPipe } from './pipes/b2b-dynamic-loader-pipe.pipe';
import { ContainerShellComponent } from '@app/b2b-dynamic-lib/components/container-shell/container-shell.component';
import { ContainerListShellComponent } from '@app/b2b-dynamic-lib/components/container-list-shell/container-list-shell.component';
import { ContainerItemListShellComponent } from '@app/b2b-dynamic-lib/components/container-item-list-shell/container-item-list-shell.component';
import { LetDirective, PushPipe } from '@ngrx/component';

@NgModule({
  imports: [
    // B2bInViewPortDirective,
    PushPipe,
    NgIf,
    NgForOf,
    AsyncPipe,
    NgStyle,
    LetDirective,
    B2bDynamicLoaderDirective,
    B2bDynamicLoaderPipe,
    ContainerShellComponent,
    ContainerListShellComponent,
    ContainerItemListShellComponent,
  ],
  exports: [
    B2bDynamicLoaderDirective,
    B2bDynamicLoaderPipe,
    ContainerShellComponent,
    ContainerListShellComponent,
    ContainerItemListShellComponent,
  ],
})
export class B2bDynamicLibModule {}
